module.exports = __webpack_public_path__ + "static/media/dark-submenu-clientes.c9f89e34.svg";